module.exports = __webpack_public_path__ + "static/actros-102e15bbc9c21638cc7f2c8e1b11fc4e.png";